/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductSelectionScenarioViewModel } from './ProductSelectionScenarioViewModel';
import {
    ProductSelectionScenarioViewModelFromJSON,
    ProductSelectionScenarioViewModelFromJSONTyped,
    ProductSelectionScenarioViewModelToJSON,
} from './ProductSelectionScenarioViewModel';

/**
 * 
 * @export
 * @interface ProductSelectionViewModel
 */
export interface ProductSelectionViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionViewModel
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionViewModel
     */
    selectedScenarioId?: number;
    /**
     * 
     * @type {Array<ProductSelectionScenarioViewModel>}
     * @memberof ProductSelectionViewModel
     */
    scenarios: Array<ProductSelectionScenarioViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSelectionViewModel
     */
    proceedWithDataLoss?: boolean;
}

/**
 * Check if a given object implements the ProductSelectionViewModel interface.
 */
export function instanceOfProductSelectionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "scenarios" in value;

    return isInstance;
}

export function ProductSelectionViewModelFromJSON(json: any): ProductSelectionViewModel {
    return ProductSelectionViewModelFromJSONTyped(json, false);
}

export function ProductSelectionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSelectionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'selectedScenarioId': !exists(json, 'SelectedScenarioId') ? undefined : json['SelectedScenarioId'],
        'scenarios': ((json['Scenarios'] as Array<any>).map(ProductSelectionScenarioViewModelFromJSON)),
        'proceedWithDataLoss': !exists(json, 'ProceedWithDataLoss') ? undefined : json['ProceedWithDataLoss'],
    };
}

export function ProductSelectionViewModelToJSON(value?: ProductSelectionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'SelectedScenarioId': value.selectedScenarioId,
        'Scenarios': ((value.scenarios as Array<any>).map(ProductSelectionScenarioViewModelToJSON)),
        'ProceedWithDataLoss': value.proceedWithDataLoss,
    };
}

